import React from "react";
import { BsCheck2Circle, BsCurrencyDollar } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";

const PriceCard = ({ index, pkg }) => {
  // console.log("index ", index);
  // console.log("pkg ", pkg);


  const handleWhatsAppClick = () => {
    const phoneNumber = "7077560638";
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div data-aos="fade-up" data-aos-duration="700" className="relative min-h-[725px] mx-auto shadow-sm xl:w-[30%] w-full rounded-3xl overflow-hidden grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10 justify-items-center">
      <div
        className={`bg-gradient-to-r h-[240px] flex items-center justify-center text-white w-full ${index % 2 === 0
          ? "from-[#3fceeb] via-[#0BB6D9] to-[#9fdce9]"
          : "from-[#0BB6D9] via-[#0BB6D9] to-[#27bcda]"
          }  absolute top-0`}
      >
        <div className="flex xl:w-fit w-[90%] mx-auto flex-col mb-5 gap-y-4 items-start justify-centers">
          <span className="flex items-center familjen-font gap-0.5 font-bold text-xl">
            <GoDotFill /> {pkg.tag}
          </span>
          <article className="flex xl:items-center items-end">
            <div data-aos="fade-up" data-aos-duration="700" className="font-bold  flex items-center">
              <span className="text-3xl familjen-font">
                Rs
              </span>
              <h1 className="lg:text-6xl familjen-font md:text-5xl text-4xl"> {pkg.price}</h1>
            </div>
            <span>/{pkg.priceDetail}</span>
          </article>
        </div>
      </div>
      <div className="w-[100] md:py-10 py-6 md:px-10 px-6 flex flex-col justify-between gap-y-4 rounded-tl-3xl rounded-tr-3xl h-[calc(735px-28%)] bg-gradient-to-tr from-[#eff1f4] via-[#f5f8fe] to-[#f5f8ff] absolute bottom-0 inset-x-0">
        {/* <article className="flex flex-col gap-y-4 border-b border-gray-500 border-dashed pb-5 sm:pb-10">
          <h4 data-aos="fade-up" data-aos-duration="700" className="md:text-3xl text-2xl font-bold familjen-font">
            {pkg.priceTitle}
          </h4>
          <p data-aos="fade-up" data-aos-duration="700" className="text-gray-700 text-[1rem]">{pkg.priceDescription}</p>
        </article> */}
        <div className="flex flex-col gap-y-3 ">
          {pkg.features.map((service, index) => (
            <div data-aos="fade-up" data-aos-duration="700" key={index} className="flex gap-3 items-center text-gray-700">
              <span className="text-[#0BB6D9] text-2xl ">
                <BsCheck2Circle />
              </span>
              <h1 className="md:text-[1rem] text-[.9rem]">{service}</h1>
            </div>
          ))}
        </div>
        <div className="w-full">
          <button onClick={() => handleWhatsAppClick()}
            className={`${index % 2 !== 0
              ? "bg-[#0BB6D9] text-white "
              : "border-black border hover:text-white"
              } font-semibold familjen-font uppercase p-3 rounded-sm w-full transition-all hover:bg-black duration-500 delay-75`}
          >
            choose plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default PriceCard;
